import { Skeleton } from '@intigral/shared';
import { __ } from '../../translations';
import { Filters } from '@intigral/shared';
import { Suspense, useContext, useEffect, useState } from 'react';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { RenderedComponent } from '../../screen/ScreenCarousel';
import { handleDataLoaderType } from '../../managers/dataLoaderHandler';
import { ComponentMapper } from '../../managers/componentMapper';
import ComponentErrorBoundary from '../../components/ComponentErrorBoundary';
import { useSelector } from 'react-redux';
import { IStore } from '../../interfaces/StoreTypes';
import { LayoutType } from '@intigral/domain/lib/entity/interface/IGetHeaderMenu';
import url from '../../helpers/url';
import { cleanupUrlWithoutReload } from '@intigral/utils/lib/helpers/browser';
import { MixpanelContext } from '../../contexts/MixpanelContext';
import { EVENT } from '../../contexts/MixpanelConstants';

interface NewAndUpcomingPropsTypes {
    components: Carousel[];
    isLoading: boolean;
    isError: any;
    layoutType?: LayoutType;
    language?: string;
}

export default function NewUpcoming({
    components,
    isLoading,
    isError,
    layoutType = 'HORIZONTAL',
    language,
}: NewAndUpcomingPropsTypes) {
    const [activeFilter, setActiveFilter] = useState(null);
    const [selectedCarousel, setSelectedCarousel] = useState(null);
    const selectedProfile = useSelector((store: IStore) => store.profile);
    const geolocation = useSelector((store: IStore) => store.location);
    const { track } = useContext(MixpanelContext);

    useEffect(() => {
        if (url.getQuery('tabIndex')) {
            handleClickFilter({
                key: atob(url.getQuery('tabIndex')?.trim?.()),
            });
        }
        // else if (getSession(STORE_NAME.NEW_AND_HOT_TAB_INDEX)) {
        //     handleClickFilter({
        //         key: url.decodeValue(getSession(STORE_NAME.NEW_AND_HOT_TAB_INDEX)),
        //     });
        // }
        else if (components?.length > 0) {
            handleClickFilter({
                key: components[0]?.id,
            });
        }
    }, [components]);

    useEffect(() => {
        return () => {
            cleanupUrlWithoutReload(['tabIndex']);
        };
    }, []);

    useEffect(() => {
        if (activeFilter && components?.length > 0) {
            const activeCarousel = components?.find((item) => item.id?.toLowerCase() === activeFilter?.toLowerCase());
            setSelectedCarousel(activeCarousel);
        }
    }, [activeFilter, components, language]);

    useEffect(() => {
        // clear tab index on refresh the page
        // const handleBeforeUnload = (event) => {
        //     event.preventDefault();
        //     event.returnValue = '';
        //     removeSession(STORE_NAME.NEW_AND_HOT_TAB_INDEX);
        // };
        // window.addEventListener('unload', handleBeforeUnload);
        // return () => {
        //     window.removeEventListener('unload', handleBeforeUnload);
        // };
    }, []);

    const handleClickFilter = (item) => {
        setActiveFilter(item?.key);
        // setSession(STORE_NAME.NEW_AND_HOT_TAB_INDEX, btoa(item?.key));
        // if (activeFilter && activeFilter !== item.key) {
        //     cleanupUrlWithoutReload(['tabIndex']);
        // }
        url.insertParamsWithoutReload({
            tabIndex: btoa(item?.key),
        });
        if (item.name) {
            track(EVENT.NEW_AND_HOT.CATEGORY_CLICK, {
                'Category Name': item.name,
            });
        }
    };

    const renderComponent = () => {
        if (activeFilter && selectedCarousel) {
            const carouselItem = { ...selectedCarousel, layoutType: layoutType };
            return (
                <RenderedComponent
                    carousel={carouselItem}
                    dataLoader={async (carousel) => {
                        const result = await handleDataLoaderType(
                            carousel as Carousel,
                            null,
                            selectedProfile,
                            geolocation
                        );
                        return result;
                    }}
                    render={(carousel, data, carouselIndex) => {
                        return (
                            <ComponentErrorBoundary>
                                <Suspense fallback={<Skeleton variant="rectangular" width="100%" height={'550px'} />}>
                                    <ComponentMapper carousel={carousel} data={data} carouselIndex={carouselIndex} />
                                </Suspense>
                            </ComponentErrorBoundary>
                        );
                    }}
                    key={carouselItem?.id}
                />
            );
        }
        return <></>;
    };
    return (
        <>
            <div className="container">
                {components?.length > 0 && (
                    <Filters
                        isLoading={isLoading}
                        items={components.map((carousel) => {
                            return {
                                key: carousel.id,
                                name: __(carousel?.title_resource_key || carousel?.id),
                                titleResourceKey: carousel?.title_resource_key || carousel?.id,
                            };
                        })}
                        handleOnClick={(item) => {
                            handleClickFilter({ ...item, name: __(item.titleResourceKey, { lng: 'en' }) });
                        }}
                        activeKey={activeFilter}
                    />
                )}
            </div>
            <div className="container">{renderComponent()}</div>
        </>
    );
}
